import React from 'react';
import PropTypes from 'prop-types';

const EndSection = props => {
    const { children, className, onClick, 'data-testid': dataTestId } = props;
    return (
        <div className={`bookmark justify-content-end ${className || ''}`.trim()} onClick={onClick} data-testid={dataTestId || undefined}>
            {children}
        </div>
    );
};

EndSection.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    onClick: PropTypes.func,
    'data-testid': PropTypes.string,
};

EndSection.defaultProps = {
    className: '',
    children: null,
    onClick: null,
    'data-testid': null,
};

export default EndSection;
